var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.options,"state":_vm.validateState('tipo_instituicao_id')},model:{value:(_vm.valueForm),callback:function ($$v) {_vm.valueForm=$$v},expression:"valueForm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }